import { render } from "./PageRisk.vue?vue&type=template&id=76255c5e&scoped=true"
import script from "./PageRisk.vue?vue&type=script&lang=js"
export * from "./PageRisk.vue?vue&type=script&lang=js"

import "./PageRisk.vue?vue&type=style&index=0&id=76255c5e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76255c5e"]])

export default __exports__